import { App, Router } from 'pylevate-runtime';
import { Chat } from './pages/chat.js';
import { Account } from './pages/account.js';
import { Keys } from './pages/keys.js';
import { Workspaces } from './pages/workspaces.js';
import { Shared } from './pages/shared.js';
import { Invite } from './pages/invite.js';
import { Billing } from './pages/billing.js';
export let app = new App({router: new Router([['/', Chat], ['/p/:id', Chat], ['/account', Account], ['/keys', Keys], ['/workspaces', Workspaces], ['/billing', Billing], ['/s/:token', Shared], ['/invite/:token', Invite]])});
app.mount('#app');